import * as React from 'react';

import * as ramda from 'ramda';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {EmailIcon} from 'shells/icon/svg/email-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EmailSeriesIcon} from 'shells/icon/svg/email-series-icon';
// @ts-expect-error - imported from .js/.jsx file
import {UserGroupIcon} from 'shells/icon/svg/user-group-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import {EmailTemplateList} from '../email-template-list';
import type {EmailComposerFormSequenceState} from '../types';

import styles from './template-row.module.css';

// @ts-expect-error
const sortTemplates = ramda.compose(ramda.sortBy(ramda.prop('position')), ramda.values);

type Props = {
    selectedTemplateId: string;
    sequence: any;
    onSequenceSelect: (sequence: EmailComposerFormSequenceState) => void;
    onTemplateSelect: (selectedSequenceId: string, selectedTemplateId: string) => void;
    isLoading: boolean;
    isSelected: boolean;
};

export function TemplateRow(props: Props) {
    const {sequence, onSequenceSelect, onTemplateSelect, selectedTemplateId, isLoading} = props;
    const isMultiEmailSequence = Object.keys(sequence.emailTemplates).length > 1;
    const SequenceIcon = isMultiEmailSequence ? EmailSeriesIcon : EmailIcon;

    return (
        <div key={sequence.id} className={styles.container}>
            <div
                onClick={() => {
                    onSequenceSelect(sequence);
                }}
                className={
                    props.isSelected ? styles['template-row--selected'] : styles['template-row']
                }
            >
                <div className='flex justify-sb align-center full-width'>
                    <StackLegacy isHorizontal={true} spacing={6} alignCenter={true}>
                        <SequenceIcon size={14} color={colors.greyLt} alignCenter={true} />
                        {sequence.name}
                    </StackLegacy>
                    {sequence.isShared ? (
                        <div data-tip='This is a shared template'>
                            <UserGroupIcon size={14} color={colors.greyLt} alignCenter={true} />
                        </div>
                    ) : undefined}
                </div>
            </div>
            {isMultiEmailSequence && props.isSelected ? (
                <EmailTemplateList
                    sequenceId={sequence.id}
                    // @ts-expect-error
                    templates={sortTemplates(sequence.emailTemplates)}
                    selectedTemplateId={selectedTemplateId}
                    onTemplateClick={(templateId: string) =>
                        onTemplateSelect(sequence.id, templateId)
                    }
                    noPadding={true}
                    isLoading={isLoading}
                />
            ) : undefined}
        </div>
    );
}
